//React
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
//LocalStorage
import SecureStorage from "react-secure-storage";
//Components
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";
//Material UI
import CoPresentIcon from '@mui/icons-material/CoPresent';
//Assets
import Logo from "../../assets/images/logo.svg";
//CSS
import "./Header.css";
const Header = () => {
  const navigate = useNavigate();
  const [profileShown, setProfileShown] = useState(false);
  const profileRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleLogout = () => {
    SecureStorage.removeItem("isLoggedIn");

    const channel = new BroadcastChannel("auth-channel");
    channel.postMessage({ type: "LOGOUT" });
    channel.close();

    navigate("/login", { replace: true });
  };

  const handleProfile = () => {
    setProfileShown(!profileShown);
  };

  // 외부 클릭 시 프로필 메뉴 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileShown(false);
      }
    };

    if (profileShown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [profileShown]);
  return (
    <div className="header-container">
      <div className="header-wrapper"
        onClick={() => {
          navigate("/home");
        }}
      >
        <Logo className="header-logo" alt="logo" />
        <div className="title">AI-FRESH</div>
      </div>
      <div ref={profileRef}>
        <CoPresentIcon className="logout-button" onClick={handleProfile}>
        </CoPresentIcon>
        <div className="profile-button"
          style={{ display: profileShown ? "block" : "none" }}
        >
          <div className="profile-userName-text">{SecureStorage.getItem("email")}</div>
          <div className="profile-changePassword-text" onClick={handleOpen}>Change Password</div>
          <div className="profile-logout-text" onClick={handleLogout}>Logout</div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <ChangePasswordModal
          open={open}
          handleClose={handleClose}
          handleOpen={handleOpen}
        />
      </div>
    </div>
  );
};

export default Header;
